let prefix = process.env.NODE_ENV === 'github' ? '/eq2cmp-host/' : '/'
module.exports = {
    publicPath: prefix
}
